import CO2ComparisonBar from "../../components/Report/Widgets/CO2ComparisonBar";
import "../PageCommon.css";
import "./Report.css";

const PlotlyReportPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <CO2ComparisonBar />
        </div>
      </div>
    </div>
  );
}

export default PlotlyReportPage;